var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpReshape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.458333 26.458334",
    height: 100,
    width: 100,
    id: "svg126",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs54"
  }, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)",
    id: "path2"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto",
    id: "marker8"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    id: "path6"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(-0.2)",
    id: "path10"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#b9b9b9",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#b9b9b9",
      fillOpacity: 1
    },
    transform: "scale(0.2)",
    id: "path14"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)",
    id: "path18"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)",
    id: "path22"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto",
    id: "marker28"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    id: "path26"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto",
    id: "marker32"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    id: "path30"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto",
    id: "marker36"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    id: "path34"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto",
    id: "marker40"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2) rotate(180) translate(6,0)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 0.0,0.0 L 5.0,-5.0 L -12.5,0.0 L 5.0,5.0 L 0.0,0.0 z ",
    id: "path38"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)",
    id: "path42"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)",
    id: "path46"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    },
    id: "marker52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)",
    id: "path50"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.802101,-321.73835)",
    id: "g74"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 322.53235,
    x: -12.210514,
    height: 24.870817,
    width: 4.0729089,
    style: {
      opacity: 1,
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect56"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.99998
    },
    transform: "matrix(1.0000213,0,0,1.0000193,2.6068129e-4,-0.00670354)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529156,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.0729089,
    height: 4.1450911,
    x: -12.210514,
    y: 343.25809,
    id: "rect58"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 339.11292,
    x: -12.210514,
    height: 4.1450911,
    width: 4.0729089,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529156,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect60"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529156,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.0729089,
    height: 4.1450911,
    x: -12.210514,
    y: 334.96774,
    id: "rect62"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 330.8226,
    x: -12.210514,
    height: 4.1450911,
    width: 4.0729089,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529156,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect64"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529156,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.0729089,
    height: 4.1450911,
    x: -12.210514,
    y: 326.67743,
    id: "rect66"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 322.53235,
    x: -12.210514,
    height: 4.1451335,
    width: 4.0729089,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529156,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect68"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.6021624,
    height: 25.4,
    x: -12.475097,
    y: 322.26752,
    ry: 0,
    id: "rect72"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.877084,-235.01749)",
    id: "g120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -65.551681,239.76672 c 0,-1.01961 -0.153737,-2.11665 1.54579,-2.11665 h 7.08786",
    style: {
      fill: "none",
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#marker15949)"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#marker16591)"
    },
    d: "m -65.551681,256.72659 c 0,1.01961 -0.153737,2.11665 1.54579,2.11665 h 7.08786",
    id: "path118"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90,150.89033,141.57012)",
    id: "g1319"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 10.424565,
    height: 15.398736,
    x: 17.178343,
    y: 276.53253,
    ry: 0,
    id: "rect1303"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 17.654602,
    y: 286.95715,
    id: "rect1305"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 286.95715,
    x: 22.628754,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect1307"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 281.98297,
    x: 17.654602,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect1309"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 22.628754,
    y: 281.98297,
    id: "rect1311"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 17.654602,
    y: 277.00879,
    id: "rect1313"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 277.00879,
    x: 22.628754,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect1315"
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 276.85004,
    x: 17.49584,
    height: 15.081241,
    width: 10.107069,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect1317"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpReshape);
export default __webpack_public_path__ + "static/media/op-reshape.10a55edd35534f5ca82032e1c2d3b015.svg";
export { ForwardRef as ReactComponent };